import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import API from '../../../utils/API'
import InputValidation from '../../../utils/InputValidation';
import commonFunctions from '../../../utils/commonFunctions';
import ModalPasswordInput from '../../../components//Modals/ModalInputs/ModalPasswordInput';

class SSOSignUp extends React.Component {
  state = {
    firstName: '',
    firstNameValid: '',
    lastName: '',
    lastNameValid: '',
    companyName: '',
    companyNameValid: '',
    companyAddress: '',
    companyAddressValid: '',
    companyPhone: '',
    companyPhoneValid: '',
    email: '',
    emailValid: '',
    password: '',
    passwordValid: '',
    passwordConfirm: '',
    passwordConfirmValid: '',
    rememberMe: false,
    error: '',
    success: '',
    name: '',
    isLogin: false,
    submitted: false,
  }
  currentPath = window.location.pathname;

  handleChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
    this.setState({ [event.target.name]: value })
    switch(event.target.name){
      case 'firstName':
        this.validateFirstName(value);
        break;
      case 'lastName':
        this.validateLastName(value);
        break;
      case 'email':
        this.validateEmail(value);
        break;
      case 'companyName':
        this.validateCompanyName(value);
        break;
      case 'companyAddress':
        this.validateCompanyAddress(value);
        break;
      case 'password':
        this.validatePassword(value);
        break;
      case 'passwordConfirm':
        this.validatePasswordConfirm(value);
        break;
      default:
        break;
    }
    //Delay to check the value, because this.setState is async
    setTimeout(() => {
      this.checkAllFieldsValid();
    }, 500);
  };

  handleCompanyPhoneChange = (value) => {
    this.setState({ companyPhone: value })
    this.validateCompanyPhone(value);
  };

  validateFirstName = (value) => {
    this.setState({firstNameValid: InputValidation.validateFirstName(value)});
  };
  
  validateLastName = (value) => {
    this.setState({lastNameValid: InputValidation.validateNameLength(value)});
  };

  validateEmail = (value) => {
    this.setState({emailValid: InputValidation.validateUserEmail(value)});
  };

  validateCompanyName = (value) => {
    this.setState({companyNameValid: InputValidation.validateNameLength(value)});
  };

  validateCompanyAddress = (value) => {
    this.setState({companyAddressValid: InputValidation.validateAddress(value)});
  };

  validateCompanyPhone = (value) => {
    this.setState({companyPhoneValid: InputValidation.validatePhone(value)});
  };

  validatePassword = (value) => {
    this.setState({passwordValid: InputValidation.validateEmpty(value) ==='' ? InputValidation.validateUserPassword(value) : InputValidation.validateEmpty(value)}, ()=>{
      this.validatePasswordConfirm(this.state.passwordConfirm); // Trigger password confirm validation
    });   
  };

  validatePasswordConfirm = (value) => {
    this.setState({passwordConfirmValid: InputValidation.validatePasswordConfirm(value, this.state.password)});
  };

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.handleLogIn(event)
    }
  }

  errorMessage = (err) => {
    switch(err.response.status) {
      case 400:
        this.setState({ error: <FormattedMessage id="INVALID_PARAMETERS" /> })
        break;
      case 401:
      case 500:
        this.setState({ error: <FormattedMessage id={err.response.data.toUpperCase()} /> })
        break;
      default:
        this.setState({ error: err.message })
    }
  }

  componentDidMount = () => {
  };

  setSuccess = (data) => {
    this.setState({ success: data })
  };

  setError = (data) => {
    this.setState({error: data })
  };

  checkAllFieldsValid() {
    if(this.state.error && !this.state.firstNameValid &&
      !this.state.lastNameValid &&
      !this.state.emailValid &&
      !this.state.companyNameValid &&
      !this.state.companyPhoneValid &&
      !this.state.companyAddressValid &&
      !this.state.passwordValid &&
      !this.state.passwordConfirmValid
    )
    {
      this.setError(null)
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitted: true });
    this.setError(null);
    // Perform field validations
    this.validateFirstName(this.state.firstName);
    this.validateLastName(this.state.lastName);
    this.validateEmail(this.state.email);
    this.validateCompanyName(this.state.companyName);
    this.validateCompanyPhone(this.state.companyPhone);
    this.validateCompanyAddress(this.state.companyAddress);
    this.validatePassword(this.state.password);
    this.validatePasswordConfirm(this.state.passwordConfirm);

    if (
      !this.state.firstNameValid &&
      !this.state.lastNameValid &&
      !this.state.emailValid &&
      !this.state.companyNameValid &&
      !this.state.companyPhoneValid &&
      !this.state.companyAddressValid &&
      !this.state.passwordValid &&
      !this.state.passwordConfirmValid
    ) {
      this.handleSignUp(e);
      this.setSuccess(<FormattedMessage id="TENANT_REGISTERED_SUCCESS" />);
    } else {
      this.setError(<FormattedMessage id="SUBMIT_ERROR" />);
      this.setSuccess(null);
    }
  };

  /**
   * Handle sign up click and register user.
   * @param {*} event 
   */
   handleSignUp(event) {
      event.preventDefault();
    
      API.register({
        firstName: this.state.firstName.trim(),
        lastName: this.state.lastName.trim(),
        email: this.state.email.trim(),
        company: this.state.companyName.trim(),
        address: this.state.companyAddress.trim(),
        companyPhone: this.state.companyPhone,
        password: this.state.password.trim(),
      })
      .then(res => {
        console.log('Successful response:', res);
    
        const { data } = res;
        if (data.error) {
          console.log('Error from server:', data.error);
          this.setError(data.error);
          this.setSuccess(null);
          return;
        } else {
          console.log('Registration successful');
          this.setSuccess(<FormattedMessage id="TENANT_REGISTERED_SUCCESS" />);
          if (this.props.onVerifyAccount) {
            this.props.onVerifyAccount(this.state.email);
          }
          this.setError(null);
        }
      })
      .catch(err => {
        console.error('Error:', err);
        this.setError(err.response ? err.response.data : <FormattedMessage id="SIGN_UP_ERROR" />);
        this.setSuccess(null);
        /*
        // Conditionally call setErrorProp if provided
        if (setErrorProp && typeof setErrorProp === 'function') {
          setErrorProp(err.response ? err.response.data : <FormattedMessage id="SIGN_UP_ERROR" />);
        }
        // Conditionally call setSuccessProp if provided
        if (setSuccessProp && typeof setSuccessProp === 'function') {
          setSuccessProp(null);
        }*/
      });
    }
  
    /**
     * Reset fields of user modal
     */
    resetFields = () => {
      this.setState(
        {
          firstName: '',
          lastName: '',
          email: '',
          companyPhone: '',
          companyName: '',
          companyAddress: '',
          password: '',
          passwordConfirm: '',
          submitted: false,
          //error: '',
          //success: '',
        }
      );
    }

    render() {
        return(
            <div className='card'>
                <div className='header text-center'>
                  <h2><FormattedMessage id="CMSE_SIGN_UP_TITLE" /></h2>
                  <h3><FormattedMessage id="CMSE_SIGN_UP_SUB_TITLE" /></h3>
                </div>
                <div className='form-outline mt-2 mb-2'>
                  <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="FIRST_NAME" /></label>
                  <input
                    onChange={this.handleChange}
                    value={this.state.firstName}
                    name='firstName'
                    className={`form-control rounded-1 ${this.state.submitted && (!this.state.firstNameValid ? 'is-valid' : 'is-invalid')}`}
                  />
                  {this.state.submitted && this.state.firstNameValid && commonFunctions.InvalidFeedbackString(this.state.firstNameValid,"FIRST_NAME")}
                </div>
                <div className='form-outline mt-2 mb-2'>
                  <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="LAST_NAME" /></label>
                  <input
                    onChange={this.handleChange}
                    value={this.state.lastName}
                    name='lastName'
                    className={`form-control rounded-1 ${this.state.submitted && (!this.state.lastNameValid ? 'is-valid' : 'is-invalid')}`}
                  />
                  {this.state.submitted && this.state.lastNameValid && commonFunctions.InvalidFeedbackString(this.state.lastNameValid,"LAST_NAME")}
                </div>
                <div className='form-outline mt-2 mb-2'>
                  <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="COMPANY_NAME" /></label>
                  <input
                    onChange={this.handleChange}
                    value={this.state.companyName}
                    name='companyName'
                    className={`form-control rounded-1 ${this.state.submitted && (!this.state.companyNameValid ? 'is-valid' : 'is-invalid')}`}
                  />
                  {this.state.submitted && this.state.companyNameValid && commonFunctions.InvalidFeedbackString(this.state.companyNameValid,"COMPANY_NAME")}
                </div>
                <div className='form-outline mt-2 mb-2'>
                  <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="COMPANY_ADDRESS" /></label>
                  <input
                    onChange={this.handleChange}
                    value={this.state.companyAddress}
                    name='companyAddress'
                    className={`form-control rounded-1 ${this.state.submitted && (!this.state.companyAddressValid ? 'is-valid' : 'is-invalid')}`}
                  />
                  {this.state.submitted && this.state.companyAddressValid && commonFunctions.InvalidFeedbackString(this.state.companyAddressValid,"COMPANY_ADDRESS")}
                </div>
                <div className='form-outline mt-2 mb-2'>
                  <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="COMPANY_PHONE" /></label>
                  <PhoneInput
                      onChange={this.handleCompanyPhoneChange}
                      name='companyPhone'
                      className={`form-control rounded-1 ${this.state.submitted && (!this.state.companyPhoneValid ? 'is-valid' : 'is-invalid')}`}
                      placeholder={this.props.intl.formatMessage({id: "ENTER_PHONE_NUMBER"})}
                      value={this.state.companyPhone}
                   />
                  {this.state.submitted && this.state.companyPhoneValid && commonFunctions.InvalidFeedbackString(this.state.companyPhoneValid,"COMPANY_PHONE")}
                </div>
                <div className='form-outline mt-2 mb-2'>
                  <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="EMAIL" /></label>
                  <input 
                    onChange={this.handleChange} 
                    value={this.state.email} 
                    name='email' 
                    type='email' 
                    className={`form-control rounded-1 ${this.state.submitted && (!this.state.emailValid ? 'is-valid' : 'is-invalid')}`} 
                  />
                  {this.state.submitted && this.state.emailValid && commonFunctions.InvalidFeedbackString(this.state.emailValid,"EMAIL")}
                </div>
                <div className='form-outline mb-2'>
                    <label className='form-label' htmlFor='form2Example2'><FormattedMessage id="PASSWORD" /></label> 
                    <ModalPasswordInput
                      onChange={this.handleChange}
                      value={this.state.password}
                      name='password'
                      isSubmitted={this.state.submitted}
                      isValid={this.state.passwordValid}
                      className={`form-control rounded-1 ${this.state.submitted && (!this.state.passwordValid ? 'is-valid' : 'is-invalid')}`}
                    />
                    {this.state.submitted && this.state.passwordValid && commonFunctions.InvalidFeedbackString(this.state.passwordValid,"PASSWORD","d-block")}                                      
                </div>
                <div className='form-outline mb-4'>
                  <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="CONFIRM_PASSWORD" /></label>
                  <ModalPasswordInput
                    onChange={this.handleChange}
                    value={this.state.passwordConfirm}
                    name='passwordConfirm'
                    isSubmitted={this.state.submitted}
                    isValid={this.state.passwordConfirmValid}
                    className={`form-control rounded-1 ${this.state.submitted && (!this.state.passwordConfirmValid ? 'is-valid' : 'is-invalid')}`}
                  />
                  {this.state.submitted && this.state.passwordConfirmValid && commonFunctions.InvalidFeedbackString(this.state.passwordConfirmValid,"CONFIRM_PASSWORD","d-block")}
                </div>
                {this.state.error ? <p className='error'>ERROR: {this.state.error}</p> : null}
                <button type='button' className='btn btn-primary btn-block' onClick={this.handleSubmit}><FormattedMessage id="CREATE_ACCOUNT_BTN" /></button>
                {/*<button type='button' className='btn btn-light mt-2' onClick={this.props.onSignIn}><FormattedMessage id="LOG_IN" /></button>*/}
            </div>
        )
    }
}

export default injectIntl(SSOSignUp);